import { render } from "./DatasetBulkInsert.vue?vue&type=template&id=4994e2b3"
import script from "./DatasetBulkInsert.vue?vue&type=script&lang=js"
export * from "./DatasetBulkInsert.vue?vue&type=script&lang=js"

import "./DatasetBulkInsert.vue?vue&type=style&index=0&id=4994e2b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__